import Chips from '../../../../../material-ui/chips/chips';
import React from 'react';
import {CorporateTableContext} from "../../../corporate-context";

function FilterChips() {

  const {filters, deleteFilter} = React.useContext(CorporateTableContext);

  return <Chips onDelete={deleteFilter} values={filters}/>
}

export default FilterChips;


